import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import StartTrialPage from "./pages/StartTrialPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminCodesPage from "./pages/AdminCodesPage";
import OnboardingPage from "./pages/OnboardingPage";
import ConversationalOnboarding from "./pages/ConversationalOnboarding";
import MentorSelectPage from "./pages/MentorSelectPage";
import DashboardPage from "./pages/DashboardPage";
import CoachPage from "./pages/CoachPage";
import VoiceCoachPage from "./pages/VoiceCoachPage";
import SharedRoadmapPage from "./pages/SharedRoadmapPage";
import FAQPage from "./pages/FAQPage";
import BetaPage from "./pages/BetaPage";
import ChallengePage from "./pages/ChallengePage";
import PracticesPage from "./pages/PracticesPage";
import PricingPage from "./pages/PricingPage";
import BillingSuccessPage from "./pages/BillingSuccessPage";
import PrivacyPage from "./pages/PrivacyPage";
import PrivacyPromisePage from "./pages/PrivacyPromisePage";
import TermsPage from "./pages/TermsPage";
import RefundPage from "./pages/RefundPage";
import SupportPage from "./pages/SupportPage";
import { AuthProvider } from "./auth/AuthContext";
import AuthCallback from "./auth/AuthCallback";
import ProtectedRoute from "./auth/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import MentorBubble from "./components/MentorBubble";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: handle OAuth return BEFORE any other route logic.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/start" element={<StartTrialPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/admin/codes" element={<ProtectedRoute requireOnboarding={false}><AdminCodesPage /></ProtectedRoute>} />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute requireOnboarding={false}>
            <ConversationalOnboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/welcome"
        element={
          <ProtectedRoute requireOnboarding={false}>
            <ConversationalOnboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mentor"
        element={
          <ProtectedRoute requireOnboarding={false}>
            <MentorSelectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding-classic"
        element={
          <ProtectedRoute requireOnboarding={false}>
            <OnboardingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/coach"
        element={
          <ProtectedRoute>
            <CoachPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/coach/voice"
        element={
          <ProtectedRoute>
            <VoiceCoachPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/practices"
        element={
          <ProtectedRoute>
            <PracticesPage />
          </ProtectedRoute>
        }
      />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/beta" element={<BetaPage />} />
      <Route path="/challenge" element={<ChallengePage />} />
      <Route path="/share/roadmap/:token" element={<SharedRoadmapPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/privacy-promise" element={<PrivacyPromisePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/refund" element={<RefundPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route
        path="/billing/success"
        element={
          <ProtectedRoute requireOnboarding={false}>
            <BillingSuccessPage />
          </ProtectedRoute>
        }
      />
    </Routes>
    <MentorBubble />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
